<mat-form-field appearance="outline" [class]="customClass" (click)="inputValue.focus()">
    <mat-label>{{dropdownChoosePlaceholder}}</mat-label>
    <mat-select [placeholder]="dropdownChoosePlaceholder" [required]="isRequired"
        (selectionChange)="inputValue.value = '';onChangeOfDropdown($event ,inputValue.value , dropdownFor)"
        [formControl]="formControlsName" [id]="idForSelect"
        (keydown.arrowup)="inputValue.value = '';onChangeOfDropdown($event ,inputValue.value , dropdownFor)"
        (keydown.arrowdown)="inputValue.value = '';onChangeOfDropdown($event ,inputValue.value , dropdownFor)"
        (keydown)="$event.stopPropagation()" #matSelect [disabled]="disabled">
        <mat-form-field appearance="outline" class="lms-mat-select-inner">
            <input matInput #inputValue [placeholder]="dropdownSearchPlaceholder" autocomplete="off"
                (input)="onKey(inputValue.value);highlightFirstOption($event)"
                (keydown.space)="$event.stopPropagation()">
            <button *ngIf="inputValue.value" mat-button matSuffix mat-icon-button [disableRipple]="true"
                (click)="inputValue.value = '';onKey(inputValue.value)" type="button">
                <div aria-label="clear" class="lms-clear-icon"></div>
            </button>
        </mat-form-field>
        <ng-container *ngIf="lists.length > 0;else elseSelectionBlock">
            <mat-option *ngFor="let item of lists" [value]="item.entityBusinessID">
                {{ item.entityBusinessName}}
            </mat-option>
        </ng-container>
        <ng-template #elseSelectionBlock>
            <mat-option style="pointer-events: none;">{{noEntriesFoundText}}</mat-option>
        </ng-template>
    </mat-select>
    <mat-error *ngIf="formControlsName?.errors?.required">
        {{requiredLabel}}
    </mat-error>
</mat-form-field>